import {LeadsInstance} from '../instancesLogApi';

export default class LeadsApi {
    static log = async (
        userId: string,
        source: string,
        origin: string,
        event: string,
        partner_user_id: string,
        doNotSell = false,
    ): Promise<undefined> => {
        const response = await LeadsInstance.post(`/${source}/${userId}/${event}`, {
            userId,
            action: event,
            data: {
                utm_origin: origin,
                utm_source: source,
                partner_user_id: partner_user_id,
                do_not_sell: doNotSell,
            },
        });

        return response.data;
    };
}
